import { ApolloError } from '@apollo/client'
import { Tooltip } from 'bold-ui'
import { useAlert } from 'components/alert'
import { useErrorHandler } from 'components/error'
import { Form, SubmitButton } from 'components/form'
import { confirm } from 'components/modals/confirm'
import { useAlterarConfiguracaoDocumentosRndsMutation } from 'graphql/hooks.generated'
import { FormRenderProps } from 'react-final-form'

import { ASSINATURA_DIGITAL_INATIVA_MESSAGE } from '../model-assinaturaDigital'
import { ServicoAssinaturaDigitalCard } from './ServicoAssinaturaDigitalCard'

interface DocumentosRndsCardProps {
  habilitado: boolean
  baseHabilitada: boolean
}

export function DocumentosRndsCard(props: Readonly<DocumentosRndsCardProps>) {
  const { habilitado, baseHabilitada } = props
  const alert = useAlert()
  const handleRejection = useErrorHandler()
  const [alterar] = useAlterarConfiguracaoDocumentosRndsMutation()

  const submitAlteracao = async (msg: string) => {
    try {
      await alterar({ variables: { habilitado: !habilitado } })
      alert('success', msg)
    } catch (error) {
      handleRejection(error as ApolloError)
    }
  }

  const handleSubmit = async () => {
    if (habilitado) {
      const confirmed = await confirm({
        title: 'Deseja desabilitar o envio de documentos à RNDS?',
        confirmLabel: 'Desabilitar',
      })()
      if (confirmed) await submitAlteracao('Envio de documentos à RNDS desabilitado com sucesso.')
    } else {
      await submitAlteracao('Envio de documentos à RNDS habilitado com sucesso.')
    }
  }

  const renderForm = (formProps: FormRenderProps) => (
    <ServicoAssinaturaDigitalCard
      habilitado={habilitado}
      titulo='Documentos para envio à RNDS'
      descricao='Habilita a assinatura digital de documentos como REPM e envio à RNDS ao finalizar um atendimento.'
    >
      <Tooltip text={!habilitado && !baseHabilitada ? ASSINATURA_DIGITAL_INATIVA_MESSAGE : ''}>
        <SubmitButton
          kind='primary'
          size='small'
          handleSubmit={formProps.handleSubmit}
          disabled={!baseHabilitada || formProps.submitting}
        >
          {habilitado ? 'Desabilitar' : 'Habilitar'}
        </SubmitButton>
      </Tooltip>
    </ServicoAssinaturaDigitalCard>
  )

  return <Form onSubmit={handleSubmit} render={renderForm} />
}
